export default {
  updateAll(state, value) {
    state.all = value
  },
  updateSingle(state, value) {
    state.single = value
  },
  updatePublishers(state, value) {
    state.publishers = value
  },
  updateUsers(state, value) {
    state.users = value
  },
  updateTypes(state, value) {
    state.types = value
  },
  updateMetaDataColumns(state, value) {
    state.metaDataColumns = value
  },
  updateMetaDataFields: (state, payload) => (state.metaDataFields = payload),
  setSubjectCategories: (state, payload) => (state.subjectCategories = payload),
  addSubjectCategory: (state, payload) => state.subjectCategories.push(payload)
}
